define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/html",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query",
	"./_ProductFormMixin"
], function(declare, lang, csi, _, def, Field, Relationship, html, reflection, xml, Query, _ProductFormMixin) {

	return declare(_ProductFormMixin, {
		FIELD_TEMPLATE: 'CopyTemplate',

		MERCH_PRODUCT: 'MerchProduct',

		// node specifying copy options
		_templateOptions: null,

		_getMerchProductFields: function(/*def.View*/formView) {
			return formView.m_fields.filter(function(f) {
				return f.m_name.indexOf("Merch") >= 0;
			});
		},

		_getTemplateOptions: function(/*Any*/value) {
			_templateOptions = this.cacheView.getNode(value, true);
		},

		_getTemplateQuery: function() {
			// summary: setup query for copy options
			var parent = this.cacheView.getNode(this.getViewNode().__Parent__, true);
			return new Query().RefAttr("Subtype", xml.OP_EQUALS, parent.Subtype);
		},

		_getTemplateType: function() {
			// summary: return type of copy options
			return "MerchProductVersionCopyTemplate";
		},

		_initFieldsFromTemplateOptions: function(/*def.View*/formView) {
			// summary: iterates through copy options and sets values based on template options
			if (!!_templateOptions) {
				var ctx = this;
				var merchFields = this._getMerchProductFields(this.defView);

				_.each(merchFields, function(field) {
					var optionName = field.m_name.replace('MerchProduct', '');
					html.setDisabled(field.m_control, _templateOptions[optionName + 'Locked']);
					ctx.setFieldValue(field, _templateOptions[optionName]);
				}, ctx);
			}
		},

		_makeMerchFieldsEditable: function(/*def.View*/formView) {
			var fields = this._getMerchProductFields(formView);

			_.each(fields, function(field) {
				html.setDisabled(field.m_control, false);
			});
		},

		_resolveView: function() {
			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_TEMPLATE,
				m_onChange: "onChangeTemplate",
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_bRequired: true,
				m_relationship: lang.mixin(new Relationship(), {
					m_url: reflection.URL_SITE,
					m_query: this._getTemplateQuery(),
					m_typeNode: this._getTemplateType()
				})
			}), 0);

			this.inherited(arguments);
		},

		onChangeTemplate: function(/*def.View*/formView, /*Field*/field, /*Any*/value) {
			// summary: re-fetches template options and resets field values
			if (value == csi.EMPTY_URL) {
				this._makeMerchFieldsEditable(formView);
				_templateOptions = null;
			} else {
				this._getTemplateOptions(value);
				this._initFieldsFromTemplateOptions(formView);
			}
		},

		onSetDefaultValue: function(/*Field*/field, /*Store*/store, /*Any*/value) {
			// summary: if there are no templates, then hide field and load default copy options; otherwise set template if there is one
			if ((value == csi.EMPTY_URL) && (field.getControlName() == this.FIELD_TEMPLATE)) {
				if (store.isStoreEmpty()) {
					this.setFieldHidden(field, true);
					this.onChangeTemplate(this.defView, field, null);
				}
			} else {
				this.inherited(arguments);
			}
		}
	});
});